import {
  CouponIcon,
  HeartHandIcon,
  ReceiptIcon,
  RefreshIcon,
} from '../../shared/ui/BottomNavIcons.js';
import type { PromotableOverflowId } from './customerNavComposition.js';

export interface PromotedNavIconEntry {
  readonly Icon: typeof HeartHandIcon;
  readonly labelKey: string;
}

export const PROMOTED_NAV_ICON_REGISTRY: Readonly<
  Record<PromotableOverflowId, PromotedNavIconEntry>
> = {
  overview: {
    Icon: CouponIcon,
    labelKey: 'account.menu.home.label',
  },
  donate: {
    Icon: HeartHandIcon,
    labelKey: 'hub.donate.label',
  },
  recurring: {
    Icon: RefreshIcon,
    labelKey: 'account.menu.recurring.label',
  },
  'my-donations': {
    Icon: ReceiptIcon,
    labelKey: 'account.menu.donations.label',
  },
};
